export const TagDefaultValue: ITag["get"] = {
    id: 0,
    faName: "",
    enName: "",
    seoName: "",
    image: "",
    url: "",
    usage: 0,
    description: "",
    isMain: false,
    seoDescription: "",
    seoKeywords: "",
    updateDateTime: "",
    createDateTime: "",
};
